/*
 * 10 % de suscriptor (FAMILY10) — lógica compartida por la barra de arriba
 * (sections/promo-klaviyo-bar.liquid) y el bloque del carrito
 * (snippets/cart-newsletter-10.liquid).
 *
 * - subscribe(): alta real en Klaviyo (lista ES o internacional), API de cliente
 *   con la clave pública. Las listas disparan la welcome series.
 * - apply(): pone el código en el carrito (/cart/update.js {discount}) para que
 *   llegue aplicado al checkout. Nunca pisa otro código que ya esté puesto.
 * - Un único flag en localStorage marca «ya suscrito» (clave heredada del antiguo banner de
 *   Arturo Alba: quien se desbloqueó ahí sigue contando como suscrito).
 */
(function () {
  var KEY = 'im-nl-gate-family10';
  var CODE = 'FAMILY10';
  var OURS = ['FAMILY10', 'SUMMER10'];
  var COMPANY = 'UCq7HK';

  function isSub() {
    try { return !!localStorage.getItem(KEY); } catch (e) { return false; }
  }

  function markSub() {
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
    document.querySelectorAll('.promo-klaviyo').forEach(function (el) { el.classList.add('is-sub'); });
  }

  function subscribe(email, firstName, source) {
    var country = ((window.Shopify && window.Shopify.country) || '').toUpperCase();
    var attrs = { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
    if (firstName) attrs.first_name = firstName;
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-01-15' },
      body: JSON.stringify({ data: {
        type: 'subscription',
        attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: attrs } } },
        relationships: { list: { data: { type: 'list', id: country === 'ES' ? 'Uq5BV2' : 'RDWPUa' } } }
      } })
    }).then(function (r) {
      if (!r.ok) throw new Error('Klaviyo ' + r.status);
      markSub();
    });
  }

  function cartRoute(path) {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + path;
  }

  function apply() {
    return fetch(cartRoute('cart.js')).then(function (r) { return r.json(); }).then(function (cart) {
      // Un código que ya aplica (el nuestro u otro) no se toca; uno que no aplica a nada se sustituye.
      if ((cart.discount_codes || []).some(function (d) { return d.applicable; })) return cart;
      return fetch(cartRoute('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: CODE })
      }).then(function (r) { return r.json(); }).then(function (updated) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: updated }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        return updated;
      });
    });
  }

  window.imNl = { isSub: isSub, markSub: markSub, subscribe: subscribe, apply: apply, ours: OURS };

  // Bloque del carrito: llega por AJAX dentro de [data-cart-subtotal], así que todo va delegado.
  var tried = {};
  function autoApply(root) {
    (root.querySelectorAll ? root : document).querySelectorAll('[data-im10][data-im10-state="offer"]').forEach(function (el) {
      if (!isSub() && !el.classList.contains('is-sub')) return;
      el.classList.add('is-sub');
      var sig = el.dataset.im10Sig;
      // Si Shopify no acepta el código para este estado del carrito (p. ej. choca con otro descuento),
      // el bloque se esconde en vez de quedarse en «Aplicando…» y no se reintenta en bucle.
      if (tried[sig] === 'failed') { el.hidden = true; return; }
      if (tried[sig] === 'pending') return;
      tried[sig] = 'pending';
      apply().then(function (cart) {
        var ok = (cart.discount_codes || []).some(function (d) { return d.applicable; });
        if (ok) delete tried[sig]; else tried[sig] = 'failed';
      }, function () { tried[sig] = 'failed'; });
    });
  }

  function submit(el) {
    var input = el.querySelector('[data-im10-email]');
    var btn = el.querySelector('[data-im10-submit]');
    var err = el.querySelector('[data-im10-error]');
    if (!input.reportValidity()) return;
    btn.disabled = true;
    err.hidden = true;
    subscribe(input.value.trim(), '', 'Carrito 10%').then(apply).catch(function () {
      err.hidden = false;
      btn.disabled = false;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-im10-submit]');
    if (btn) { e.preventDefault(); submit(btn.closest('[data-im10]')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-im10-email]')) {
      e.preventDefault();
      submit(e.target.closest('[data-im10]'));
    }
  });

  // Alta por el popup de Klaviyo de la barra: mismo flag y mismo autoaplicado.
  window.addEventListener('klaviyoForms', function (e) {
    if (e.detail && e.detail.type === 'submit') { markSub(); apply(); }
  });

  // Solo se vigila el hueco del subtotal (drawer y /cart), que es lo que el tema repinta.
  var mo = new MutationObserver(function () { autoApply(document); });
  document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) { mo.observe(el, { childList: true }); });
  // El tema no reescribe el subtotal si no ha cambiado (loadForm en theme.js): sin mutación, también se
  // revisa en cada cambio de carrito y al abrir el cajón.
  document.addEventListener('theme:cart:change', function () { setTimeout(function () { autoApply(document); }, 0); });
  document.addEventListener('theme:drawer:open', function () { autoApply(document); }, true);
  autoApply(document);
})();
